class Cookie {
  constructor(cname) {
    this.name = cname + "=";
    this.decodedCookie = decodeURIComponent(document.cookie);
  }

  get() {
    var ca = this.decodedCookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(this.name) == 0) {
        return c.substring(this.name.length, c.length);
      }
    }
    return "";
  }
}

document.addEventListener("turbo:load", function() {
  document.querySelectorAll('[data-behaviour="cookie"]').forEach((elt)=>{
    var cookie = new Cookie(elt.getAttribute('data-cookie'));
    elt.value = cookie.get();
  })
});